// equipmentRoutes.ts
import type { RouteRecordRaw } from "vue-router";
import equipmentRoutesConfig from "./config/equipment";
import Casing from "@/views/equipmentAdmin/Casing.vue";
import Intake from "@/views/equipmentAdmin/Intake.vue";
import Housing from "@/views/equipmentAdmin/Housing.vue";
import MLE from "@/views/equipmentAdmin/MLE.vue";
import Motor from "@/views/equipmentAdmin/Motor.vue";
import HpsMotors from "@/views/equipmentAdmin/HpsMotor.vue";
import HpsIntake from "@/views/equipmentAdmin/HpsIntake.vue";
import Cable from "@/views/equipmentAdmin/Cable.vue";
import Pump from "@/views/equipmentAdmin/Pump.vue";
import Seal from "@/views/equipmentAdmin/Seal.vue";
import SealMotorOil from "@/views/equipmentAdmin/SealMotorOil.vue";
import Sensor from "@/views/equipmentAdmin/Sensor.vue";
import Switchboard from "@/views/equipmentAdmin/Switchboard.vue";
import StepDownTransformer from "@/views/equipmentAdmin/StepDownTransformer.vue";
import StepUpTransformer from "@/views/equipmentAdmin/StepUpTransformer.vue";
import Tubing from "@/views/equipmentAdmin/Tubing.vue";
import VSD from "@/views/equipmentAdmin/VSD.vue";
import type { Component } from "vue";
import SealThrustChambers from "@/views/equipmentAdmin/SealThrustChambers.vue";
import YTool from "@/views/equipmentAdmin/YTool.vue";
import BoltOnDischarge from "@/views/equipmentAdmin/BoltOnDischarge.vue";
import HpsBoltOnDischarge from "@/views/equipmentAdmin/HpsBoltOnDischarge.vue";

const componentMap: { [key: string]: Component } = {
  Casing,
  Intake,
  Housing,
  MLE,
  Motor,
  Cable,
  Pump,
  Seal,
  SealMotorOil,
  Sensor,
  Switchboard,
  StepDownTransformer,
  StepUpTransformer,
  Tubing,
  VSD,
  SealThrustChambers,
  HpsMotors,
  HpsIntake,
  YTool,
  BoltOnDischarge,
  HpsBoltOnDischarge
};

const EquipmentRoutes: Array<RouteRecordRaw> = equipmentRoutesConfig.map(
  ({ path, name, meta, componentName }) => {
    return {
      path,
      name,
      meta,
      component: componentMap[componentName]
    };
  }
);

export default EquipmentRoutes;
